import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSLocationIntegrationsCollection = GenericCollectionFactory("PMS_LOCATION_INTEGRATIONS", "uid")